import branding from '@/public/images/landing/productivity/branding.webp';
import education from '@/public/images/landing/productivity/education.webp';
import food from '@/public/images/landing/productivity/food.webp';
import other from '@/public/images/landing/productivity/other.webp';
import estate from '@/public/images/landing/productivity/realEstate.webp';
import { type TProductivityItem } from '../../types';

export const productivityData: TProductivityItem[] = [
	{
		id: 'estate',
		icon: '🏠',
		name: 'estate_button',
		title: 'estate_title',
		list: ['estate_item1', 'estate_item2', 'estate_item3'],
		image: estate,
	},
	{
		id: 'branding',
		icon: '💁‍♀️',
		name: 'branding_button',
		title: 'branding_title',
		list: ['branding_item1', 'branding_item2', 'branding_item3'],
		image: branding,
	},
	{
		id: 'education',
		icon: '📚',
		name: 'education_button',
		title: 'education_title',
		list: ['education_item1', 'education_item2', 'education_item3'],
		image: education,
	},
	{
		id: 'food',
		icon: '🍤',
		name: 'food_button',
		title: 'food_title',
		list: ['food_item1', 'food_item2', 'food_item3'],
		image: food,
	},
	{
		id: 'other',
		icon: '🦄',
		name: 'other_button',
		title: 'other_title',
		list: ['other_item1', 'other_item2', 'other_item3'],
		image: other,
	},
];
